import { EGarageKind } from '../../../../json_query';
import { changeGarageKind } from '../../../state/advanced/garage_kind';
import { getMultiSelectParam } from './abstract_params/multi_select_param';

export const GarageKindParam = getMultiSelectParam<EGarageKind>(
  'Тип гаража',
  [
    { title: 'Встроенный', value: EGarageKind.Builtin },
    { title: 'Капитальный', value: EGarageKind.Capital },
    { title: 'Ракушка', value: EGarageKind.Shell },
    { title: 'Самострой', value: EGarageKind.Selfbuilt },
  ],
  'garage_garage_type',
  changeGarageKind,
);
